import {API_URL} from "../config/constants";
import axios from "axios";

export const OffreService = {
  // Get all active offers for public display
  getActive: () => {
    return axios
      .get(API_URL + "offres/active")
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching active offers:", error);
        throw error;
      });
  },

  // Get all offers for admin
  getAll: () => {
    return axios
      .get(API_URL + "offres/")
      .then((res) => res)
      .catch((error) => {
        console.error("Error fetching all offers:", error);
        throw error;
      });
  },

  // Get single offer by ID
  getById: (id) => {
    return axios
      .get(API_URL + "offres/" + id)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching offer:", error);
        throw error;
      });
  },

  // Create new offer
  create: (data) => {
    return axios
      .post(API_URL + "offres/", data)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error creating offer:", error);
        throw error;
      });
  },

  // Update offer
  update: (id, data) => {
    return axios
      .put(API_URL + "offres/" + id, data)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error updating offer:", error);
        throw error;
      });
  },

  // Delete offer
  delete: (id) => {
    return axios
      .delete(API_URL + "offres/" + id)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleting offer:", error);
        throw error;
      });
  }
};

// Keep backward compatibility
export default OffreService; 